/* esm.sh - d3-transition@3.0.1/src/transition/remove */
export * from "/*d3-transition@3.0.1/esnext/src/transition/remove.mjs";
export { default } from "/*d3-transition@3.0.1/esnext/src/transition/remove.mjs";
